import { createRouter, createWebHistory } from 'vue-router'
import { setupRouterGuard } from './guard'

const router = createRouter({
  history: createWebHistory(),
  routes: [
    // 通知相关路由
    { path: '/notice/:id', component: () => import('../views/notice/NoticeDetail.vue') },

    // 报告相关路由
    { path: '/report/create', component: () => import('../views/report/ReportCreate.vue') },
    { path: '/report/visit-log', component: () => import('../views/report/ReportCreate.vue') },
    { path: '/report/sales', component: () => import('../views/report/ReportCreate.vue') },
    { path: '/report/business', component: () => import('../views/report/ReportCreate.vue') },
    { path: '/my-reports', component: () => import('../views/report/MyReports.vue') },
    { path: '/my-created', component: () => import('../views/report/MyReports.vue') },
    { path: '/my-received', component: () => import('../views/report/MyReports.vue') },
    { path: '/my-stats', component: () => import('../views/report/MyStats.vue') },
    { path: '/report-detail/:id', component: () => import('../views/report/ReportDetail.vue') },
    { path: '/report-submit-success', component: () => import('../views/report/ReportSubmitSuccess.vue') },

    // 待办通知只读落地；写操作回 App / PC 原生详情
    { path: '/todo-detail/:id', component: () => import('../views/todo/TodoDetail.vue') },

    // 收集表单相关路由
    { path: '/collection-create', component: () => import('../views/collection/CollectionCreate.vue') },
    { path: '/collection-edit', component: () => import('../views/collection/CollectionEdit.vue') },
    { path: '/collection-fill/:id', component: () => import('../views/collection/CollectionFill.vue') },
    { path: '/collection-templates', component: () => import('../views/collection/CollectionTemplates.vue') },
    { path: '/collection-quick', component: () => import('../views/collection/CollectionQuick.vue') },
    { path: '/collection-drafts', component: () => import('../views/collection/CollectionDrafts.vue') },
    { path: '/template-preview/:id', component: () => import('../views/collection/TemplatePreview.vue') },
    { path: '/collection-publish-success', component: () => import('../views/collection/CollectionPublishSuccess.vue') },

    // 投票相关路由
    { path: '/vote-list', component: () => import('../views/vote/VoteList.vue') },
    { path: '/vote-create', component: () => import('../views/vote/VoteCreate.vue') },
    { path: '/vote-detail', component: () => import('../views/vote/VoteDetail.vue') },
    { path: '/vote-participate', component: () => import('../views/vote/VoteParticipate.vue') },

    // 会议相关路由
    { path: '/meeting/detail', component: () => import('../views/meeting/Detail.vue') },
    { path: '/meeting/invite/:token', component: () => import('../views/meeting/InviteLanding.vue') },
    // 面对面会议：外部手机浏览器匿名访客入会（不带登录态，RTC 凭证仅存内存）
    { path: '/meeting/guest/prejoin/:token', component: () => import('../views/meeting/GuestPrejoin.vue') },
    { path: '/meeting/guest/room/:token', component: () => import('../views/meeting/GuestRoom.vue') },

    // 项目邀请公开落地页（h5.tonglian.chat/dfc/{projectId}/{code}，备用 h5.qdtg.work）
    { path: '/dfc/:projectId/:code', component: () => import('../views/project/ProjectInviteLanding.vue') },

    // 二维码短期 token 解析（App / H5 扫码入会、加好友、加群）
    { path: '/qr/invite', component: () => import('../views/qr/QrInvite.vue') },

    // 获客链接落地页（员工「添加客户」公开页，展示脱敏员工+企业信息）
    { path: '/cw/:token', component: () => import('../views/qr/ContactLanding.vue') },

    // 默认重定向
    { path: '/', redirect: '/my-reports' },
  ],
})

setupRouterGuard(router)

export default router
